import { format } from "date-fns";
import {
  Autocomplete,
  Button,
  DataGrid,
  DatePicker,
  DialogActions,
  DialogContent,
  Grid,
  Loading,
  TextField,
} from "../../../../../components";
import { InputErros, value } from "../../../../../helpers";
import { formatDate } from "../../../../../utils";
import { useState } from "react";
import { notification } from "../../../../../services";

const CarnePagamentoStepper = ({
  activeStep,
  setActiveStep,
  loading,
  listNfSaida,
  listContasReceber,
  listaClientes,
  listaOperacoesFiscais,
  listaMeiosPagamento,
  handleInputChange,
  handleDateChange,
  onChangeAutocomplete,
  nfSaidaSelecionado,
  setNfSaidasSelecionado,
  contasReceberSelecionadas,
  setContasReceberSelecionadas,
  buscarNfSaida,
  buscarContasReceber,
  filtrosDialog,
  gerarCarne,
  colunas,
  onClose,
}) => {
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const colunasNfSaida = [
    {
      field: "serieDocumento",
      headerName: "Série",
      width: 100,
      valueGetter: (params) => value.text(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Documento",
      flex: 170,
      filtrar: true,
    },
    {
      field: "operacaoFiscalId",
      headerName: "Operação Fiscal",
      flex: 250,
      valueGetter: (params) =>
        listaOperacoesFiscais.find((item) => item.id == params.value)
          ?.descricao,
    },
    {
      field: "createdAt",
      headerName: "Data de Lançamento",
      width: 200,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "clienteNome",
      headerName: "Cliente",
      width: 300,
      sortable: false,
      valueGetter: (params) =>
        params.value ??
        listaClientes.find((item) => item.id == params.row.clienteId)
          ?.nomeRazaoSocial,
    },
  ];

  const handleAvancarStep = () => {
    if (!nfSaidaSelecionado?.length)
      return notification.alertaGenericos(
        "Selecione ao menos uma NF para importar"
      );
    buscarContasReceber();
    setActiveStep(activeStep + 1);
  };

  switch (activeStep) {
    case 1:
      return (
        <>
          <DialogContent>
            <DataGrid
              rows={listContasReceber}
              columns={colunas}
              checkboxSelection
              selectionModel={contasReceberSelecionadas}
              onRowSelectionModelChange={(event) => {
                setContasReceberSelecionadas(event);
              }}
              disableRowSelectionOnClick
              paginationMode={"server"}
              // sendServer={sendServer}
              disableAcoes
              noFilter
            />
            <Loading loading={loading} />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              color="padrao"
              variant="contained"
              onClick={() => onClose()}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setNfSaidasSelecionado([]);
                setActiveStep(activeStep - 1);
              }}
            >
              <i
                className="ph-fill ph-caret-left"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Anterior
            </Button>
            <Button color="primary" variant="contained" onClick={() => gerarCarne()}>
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Gerar
            </Button>
          </DialogActions>
        </>
      );
    default:
      return (
        <>
          <DialogContent>
            <Grid container spacing={2} className="mt-1 mb-4">
              <Grid item xs={2}>
                <DatePicker
                  id="dataInicial"
                  name="dataInicial"
                  label="Data Inicial"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataInicial
                      ? filtrosDialog.dataInicial
                      : null
                  }
                  onChange={(date) => handleDateChange(date, "dataInicial")}
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  id="dataFinal"
                  name="dataFinal"
                  label="Data Final"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataFinal ? filtrosDialog.dataFinal : null
                  }
                  onChange={(date) => handleDateChange(date, "dataFinal")}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  id="clienteId"
                  name="clienteId"
                  options={listaClientes}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.nomeRazaoSocial
                      ? `${option.id}` + ` - ` + `${option.nomeRazaoSocial}`
                      : ""
                  }
                  getOptionSelected={(option, value) =>
                    option?.nomeRazaoSocial === value?.nomeRazaoSocial
                  }
                  noOptionsText="Sem opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      variant={"outlined"}
                      error={inputErros.get("clienteId")}
                    />
                  )}
                  onChange={(e, value) =>
                    onChangeAutocomplete("clienteId", value)
                  }
                  value={value.autoComplete(
                    listaClientes,
                    filtrosDialog?.clienteId
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="numeroDocumento"
                  name="numeroDocumento"
                  label="Nº do documento"
                  variant="outlined"
                  value={
                    filtrosDialog.numeroDocumento
                      ? filtrosDialog.numeroDocumento
                      : undefined
                  }
                  onChange={handleInputChange}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} className="d-flex align-items-center">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={!listaMeiosPagamento?.length}
                  fullWidth
                  sx={{ height: "51px" }}
                  onClick={() => buscarNfSaida(filtrosDialog)}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#fff", fontSize: 18, marginRight: 10 }}
                  ></i>
                  Filtrar
                </Button>
              </Grid>
            </Grid>
            <DataGrid
              rows={listNfSaida}
              columns={colunasNfSaida}
              checkboxSelection
              selectionModel={nfSaidaSelecionado}
              onRowSelectionModelChange={(event) => {
                setNfSaidasSelecionado(event.slice(-1));
              }}
              paginationMode={"server"}
              disableAcoes
              noFilter
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              color="padrao"
              variant="contained"
              onClick={() => onClose()}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={!listaMeiosPagamento?.length}
              onClick={() => handleAvancarStep()}
            >
              Próximo
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            </Button>
          </DialogActions>
        </>
      );
  }
};

export default CarnePagamentoStepper;
